import { styled } from "../../gatsby-theme-stitches/config"

export const Text = styled("h1", {
  fontFamily: "$space",
  color: "inherit",
  fontWeight: "500",
  variants: {
    variant: {
      "heading-1": {
        fontSize: "$mobile-heading-1",
        fontWeight: "500",
        lineHeight: "1.5",
        "@desktop": {
          fontSize: "$heading-1",
        },
      },
      "heading-2": {
        fontSize: "$heading-2",
      },
      "body-1": {
        fontSize: "$body-1",
      },
      "body-2": {
        fontSize: "$body-2",
      },
      "body-3": {
        fontSize: "$body-3",
      },
      "subtitle-1": {
        fontSize: "$body-1",
        fontWeight: "600",
      },
    },
  },
})
